import React from 'react';
import PropTypes from "prop-types";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Alert } from 'reactstrap';

const ModalWrapper = props => {

  const modalClass = props.modalType ? `modal-${props.modalType}` : null;

  const toggleModal = () => {
    props.toggleModal();
  }

  const lodadDefault = () => {
    return (
      <React.Fragment>
        { props.description }
        { props.error && <Alert color="danger">
                  { props.error.userMessage }
                </Alert>}
      </React.Fragment>
    )
  }

  return (
    <Modal 
        isOpen={ props.isOpen } 
        toggle={ toggleModal }
        className={ modalClass || 'modal-danger' }
      >
      <ModalHeader toggle={ toggleModal }>{ props.title || 'Title' }</ModalHeader>
      <ModalBody> 
        { props.children || lodadDefault() }
      </ModalBody>
      <ModalFooter>
        <Button disabled={ props.loading } color={ props.modalType } onClick={ props.handleAction }>Yes</Button>{' '}
        <Button color="secondary" onClick={ toggleModal }>Cancel</Button>
      </ModalFooter>
    </Modal>
  )
}

ModalWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  isOpen: PropTypes.bool.isRequired,
  modalType: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  error: PropTypes.object,
  toggleModal: PropTypes.func.isRequired,
  handleAction: PropTypes.func,
};

// Same approach for defaultProps too
ModalWrapper.defaultProps = {
  isOpen: false,
  title: 'Title',
  modalType: 'danger'
};
export default ModalWrapper;


// WEBPACK FOOTER //
// ./src/views/Components/Modal.js